import { flow, Instance, types } from 'mobx-state-tree';
import Common from '@store/common';
import axios from 'axios';
import endpoints from '@configs/endpoints';
import { IDLocalPaymentData, ICardInfo } from '@containers/checkout/payment-form/types';
import debug from 'debug';
import { sendEvent } from '@utils/ga';
import { ACTIONS, CATEGORIES } from '@constants/analytics';
import { Partner } from '@constants/paymentLink';
import GenericSpei from '@store/genericSpei';

const error = debug('DLocalStore:error');

export class Redirect3dSecureError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'Redirect3dSecureError';
  }
}

const DLocalStore = types.compose(Common, types.model({}), GenericSpei).actions((self) => ({
  initCardPaymentTransaction: flow(function* (payload: IDLocalPaymentData, cardInfo?: ICardInfo) {
    try {
      const body = {
        token: payload.token,
        paymentLinkId: payload.paymentLinkId,
        payeeFirstName: payload.payeeFirstName,
        payeeLastName: payload.payeeLastName,
        payeeEmail: payload.payeeEmail.trim(),
        payeePhone: payload.payeePhone.replace(/\s/g, ''),
        deviceId: payload.deviceId,
        confirmationUrl: payload.confirmationUrl,
        partner: Partner.DLOCAL,
        cardInfo,
      };
      const { data } = yield axios.post(endpoints.processCardPayment, body);
      const { metadata, success } = data;
      const gaEvent = {
        category: CATEGORIES.CHECKOUT.CATEGORY,
        action: ACTIONS.SUBMIT,
      };
      if (!metadata && success) {
        self.globalStore.checkout.success.set('cardPayment', true);
        sendEvent({
          ...gaEvent,
          label: CATEGORIES.CHECKOUT.LABELS.CREDIT_CARD_ACCEPTED,
        });
        return null;
      }
      if (!metadata.redirectUrl) {
        sendEvent({
          ...gaEvent,
          label: CATEGORIES.CHECKOUT.LABELS.CREDIT_CARD_DECLINED,
          dimension1: data.errors?.message,
        });
        throw new Redirect3dSecureError('No redirectUrl found');
      }
      return data;
    } catch (e) {
      error('Error trying init dlocal card payment transaction', e);
      throw e;
    }
  }),
}));

export type IDLocalStore = Instance<typeof DLocalStore>;
export default DLocalStore;
